import {Component, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {NavService} from '../../../services/nav.service';
import {QuizService} from '../quiz.service';
import {JourneyDelegateTemplateModel} from '../../journey/models/journey-page.model';


@Component({
    selector: 'quiz-page',
    templateUrl: './quiz.page.html',
    styleUrls: ['./quiz.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class QuizPage implements OnInit {

    session = null;
    userInfo: UserInfoModel = null;
    template: JourneyDelegateTemplateModel = null;
    url = null;

    constructor(
        public sanitizer: DomSanitizer,
        public userService: UserService,
        private quizService: QuizService,
        private route: ActivatedRoute,
        private nav: NavService
    ) {}

    ngOnInit() {
        this.session = parseInt(this.route.snapshot.paramMap.get("session"), 10);

        if (!this.session || this.session < 1 || this.session > 4) {
            this.nav.navigateHome();
        } else {
            this.userInfo = this.userService.getCurrentUserInfo(false);
            if (this.userInfo !== null) {
                this.initQuizPage();
            } else {
                this.userService.getUserInfo()
                    .then((userInfo) => {
                        this.userInfo = userInfo;
                        this.initQuizPage();
                    });
            }
        }
    }

    initQuizPage() {
        this.template = this.userInfo.templates.find((t) => t.template.uid === 'V' + (this.session + 1).toString())
        if (!this.template) {
            console.log(this.template);
            // this.nav.navigateHome();
        } else {
            this.quizService.getMyJourneyStage(1, this.template.template_id)
                .then((stage) => {
                    if (!!stage && !!stage.details.list && stage.details.list.length && !!stage.details.list[0].url) {
                        this.url = stage.details.list[0].url;
                    }
                })
        }
    }
}
